var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#323130",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.62783 0.024577C4.22317 -0.322077 0.37147 2.96758 0.0248156 7.37224C-0.321839 11.7769 2.96782 15.6286 7.37248 15.9753C11.7771 16.3219 15.6288 13.0322 15.9755 8.62759C15.9978 8.34413 16.0041 8.03956 15.995 7.73844C15.9826 7.32441 15.6369 6.99883 15.2229 7.01124C14.8089 7.02365 14.4833 7.36935 14.4957 7.78338C14.5032 8.03197 14.498 8.2825 14.4801 8.5099C14.1985 12.0887 11.069 14.7615 7.49017 14.4799C3.91138 14.1982 1.23853 11.0687 1.52019 7.48993C1.80185 3.91115 4.93135 1.2383 8.51014 1.51995C10.2464 1.6566 11.8159 2.47041 12.9225 3.75463L13.126 4.00251L10.7472 4.00338L10.6455 4.01023C10.2794 4.05989 9.99723 4.37368 9.99723 4.75338C9.99723 5.13308 10.2794 5.44687 10.6455 5.49653L10.7472 5.50338H14.7472L14.8489 5.49653C15.1817 5.45139 15.4452 5.18795 15.4903 4.85515L15.4972 4.75338V0.75338L15.4903 0.65161C15.4452 0.318814 15.1817 0.0553747 14.8489 0.010227L14.7472 0.00338036L14.6454 0.010227C14.3126 0.0553747 14.0492 0.318814 14.004 0.65161L13.9972 0.75338L13.9984 2.70613C12.6405 1.16623 10.7325 0.190215 8.62783 0.024577Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.8dc127352ee3a43273de223f7b39f943.svg";
export { ForwardRef as ReactComponent };